import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography, Avatar } from '@material-ui/core';
import classnames from 'classnames';

import { getTaskColor } from '../utils/programUtils';

const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1),
        fontSize: theme.sizes.largeAvatar,

        '@media print': {
            display: 'none',
        },
    },
});

class TaskName extends React.Component {
    render() {
        const {
            classes, task, className,
        } = this.props;

        return (
            <div className={classnames(classes.root, className)}>
                <Avatar className={classes.avatar} style={{ background: getTaskColor(task) }}>{task.name.slice(0, 1)}</Avatar>
                <Typography variant="subtitle1">
                    {task.name}
                </Typography>
            </div>
        );
    }
}

TaskName.propTypes = {
    classes: PropTypes.object.isRequired,
    task: PropTypes.object.isRequired,
    className: PropTypes.string,
};

TaskName.defaultProps = {
    className: null,
};

export default withStyles(styles)(TaskName);
